import React from 'react'
import { RecipeStep as RecipeStepType } from '../types/recipe'
import { APP_SETTINGS } from '../../../constants/settings'

interface RecipeStepProps {
  step: RecipeStepType
  stepNumber: number
  totalSteps: number
  hasTouchScreen: boolean
}

const RecipeStep: React.FC<RecipeStepProps> = ({ 
  step, 
  stepNumber, 
  totalSteps,
  hasTouchScreen 
}) => {
  // Use different font sizes based on device type
  const fontSize = hasTouchScreen ? 
    APP_SETTINGS.TOUCH_FONT_SIZE : 
    APP_SETTINGS.STEPS_FONT_SIZE
  
  return (
    <div className="w-full h-full flex flex-col justify-center px-8">
      <div className="mb-6 flex justify-between items-center">
        <h2 
          className="text-3xl font-semibold text-white"
          style={{ fontSize: `${fontSize + 4}px` }}
        >
          Step {stepNumber + 1} of {totalSteps}
        </h2>
        
        {step.durationMinutes && (
          <div className="bg-gray-800 rounded-full px-4 py-2 text-white">
            {step.durationMinutes} {step.durationMinutes === 1 ? 'minute' : 'minutes'}
          </div>
        )}
      </div>
      
      <div 
        className="bg-gray-800 rounded-lg p-8 mb-8 text-white shadow-lg"
        style={{ fontSize: `${fontSize}px` }}
      >
        <p className="leading-relaxed">
          {step.instructions}
        </p>
        
        {step.notes && (
          <div className="mt-4 pt-4 border-t border-gray-700">
            <p className="text-gray-300 italic">{step.notes}</p>
          </div>
        )}
      </div>
      
      {step.imageUrl && (
        <div className="mt-auto">
          <img 
            src={step.imageUrl} 
            alt={`Step ${stepNumber + 1}`}
            className="rounded-lg max-h-60 object-cover mx-auto"
          />
        </div>
      )}
      
      {step.isOptional && (
        <div className="mt-4 text-gray-400 text-center italic">
          This step is optional.
        </div>
      )}
    </div>
  )
}

export default RecipeStep
